import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';

@Component({

    selector: 'checkout',
    templateUrl: 'checkout.component.html',
    styleUrls: ['checkout.component.scss']
})
export class CheckoutComponent {
    isAuthenticated: boolean = false;
    activestep = 1;
    subscriptions: Subscription[] = [];
    constructor(
        private webSiteUsersService: WebSiteUsersService,
    ) {
        let sub = this.webSiteUsersService.listener.subscribe(
            log => {
                this.isAuthenticated = log
            }
        )
        this.subscriptions.push(sub);
    }
    next() {
        if (this.activestep == 1) {
            this.activestep = (this.isAuthenticated) ? 3 : 2
        } else {
            this.activestep = 3;
        }
    }
    goTostep(i) {
        if (i < this.activestep) {
            this.activestep = i;
        }
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
